import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from "../ui/alert-dialog";
import { useLanguage } from "../../i18n/language-provider";
import {
    cancelPendingNavigation,
    confirmPendingNavigation,
    usePendingNavigation,
} from "../../navigation/history";

/**
 * The one "discard changes?" question, whatever was about to lose them: a
 * click on the rail, the browser's own Back or Forward, or a property switch.
 *
 * It used to be two dialogs — the shell's, for rail clicks, and the strategy
 * editor's own, for its close button — and neither could hear the browser's
 * buttons at all, because a Back press is over before anyone is told of it.
 * The history store holds the move (and undoes a Back) until this answers.
 */
export function NavigationGuardDialog() {
    const { t } = useLanguage();
    const pending = usePendingNavigation();

    return (
        <AlertDialog
            open={pending !== null}
            onOpenChange={(open) => {
                if (!open) cancelPendingNavigation();
            }}
        >
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>{t.strategies.discardChangesTitle}</AlertDialogTitle>
                    <AlertDialogDescription>{t.strategies.discardChangesDesc}</AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel>{t.common.cancel}</AlertDialogCancel>
                    <AlertDialogAction
                        onClick={confirmPendingNavigation}
                        className="bg-destructive text-white hover:bg-destructive/90"
                    >
                        {t.strategies.discardChangesAction}
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
